import { getUserDetail } from 'common/api/companies';

import {
    FETCH_USER_DETAIL,
    FETCH_USER_DETAIL_FAILURE,
    FETCH_USER_DETAIL_SUCCESS,
} from '../actionTypes';
import { companyUsersActions } from '../reducer';

import initializeForm from './initializeForm';
import resetForm from './resetForm';
import toggleModalUser from './toggleModalUser';

export default (companyId, user) => (dispatch) => {
    dispatch(companyUsersActions[FETCH_USER_DETAIL]());
    dispatch(resetForm());
    dispatch(toggleModalUser(true));

    getUserDetail(companyId, user.id)
        .then((response) => {
            dispatch(
                companyUsersActions[FETCH_USER_DETAIL_SUCCESS](response.data),
            );

            const values = {
                ...response.data,
                company_group: response.data.company_group.id,
                type: response.data.company_group.type,
                owner_type: response.data.company_group.owner_type,
                isOwner:
                    parseInt(response.data.company_group.type) === 0 &&
                    parseInt(response.data.company_group.owner_type) === 0,
                company_id: companyId,
            };

            dispatch(initializeForm(values));
        })
        .catch((error) =>
            dispatch(
                companyUsersActions[FETCH_USER_DETAIL_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
